/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Edit_Unsaved_ChangesInputs */

const en_case_edit_unsaved_changes = /** @type {(inputs: Case_Edit_Unsaved_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`There are unsaved case changes. They will be lost. Do you want to continue?`)
};

const pt_br2_case_edit_unsaved_changes = /** @type {(inputs: Case_Edit_Unsaved_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Existem alterações não salvas no caso. Elas serão perdidas. Deseja continuar?`)
};

/**
* | output |
* | --- |
* | "There are unsaved case changes. They will be lost. Do you want to continue?" |
*
* @param {Case_Edit_Unsaved_ChangesInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_edit_unsaved_changes = /** @type {((inputs?: Case_Edit_Unsaved_ChangesInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Edit_Unsaved_ChangesInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_edit_unsaved_changes(inputs)
	return pt_br2_case_edit_unsaved_changes(inputs)
});